/**
 * Husleie.no API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0
 * Contact: devops+api@husleie.no
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import DefaultErrorResponseScheme from '../model/DefaultErrorResponseScheme';
import InlineResponse200 from '../model/InlineResponse200';
import InlineResponse2001 from '../model/InlineResponse2001';
import InlineResponse2002 from '../model/InlineResponse2002';
import InlineResponse201 from '../model/InlineResponse201';
import InlineResponse2011 from '../model/InlineResponse2011';

/**
 * Archive service.
 * @module api/ArchiveApi
 * @version 1.0
 */
export default class ArchiveApi {

    /**
     * Constructs a new ArchiveApi. 
     * @alias module:api/ArchiveApi
     * @class
     * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
     * default to {@link module:ApiClient#instance} if unspecified.
     */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the createDocument operation.
     * @callback module:api/ArchiveApi~createDocumentCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InlineResponse201} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates a document
     * Creates a document in the archive for storage and retrievals
     * @param {String} slug 
     * @param {Object} opts Optional parameters
     * @param {Date} opts.expires 
     * @param {String} opts.filename 
     * @param {String} opts.language 
     * @param {Boolean} opts.renderOnCreate 
     * @param {Number} opts.userId 
     * @param {Object} opts.variables 
     * @param {module:api/ArchiveApi~createDocumentCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/InlineResponse201}
     */
    createDocument(slug, opts, callback) {
        opts = opts || {};
        let postBody = null;

        // verify the required parameter 'slug' is set
        if (slug === undefined || slug === null) {
            throw new Error("Missing the required parameter 'slug' when calling createDocument");
        }


        let pathParams = {};
        let queryParams = {};
        let headerParams = {};
        let formParams = {
            'expires': opts['expires'],
            'filename': opts['filename'],
            'language': opts['language'],
            'render_on_create': opts['renderOnCreate'],
            'slug': slug,
            'user_id': opts['userId'],
            'variables': opts['variables']
        };

        let authNames = ['APIKeyHeader'];
        let contentTypes = ['multipart/form-data'];
        let accepts = ['*/*'];
        let returnType = InlineResponse201;

        return this.apiClient.callApi(
            '/archive/documents', 'POST',
            pathParams, queryParams, headerParams, formParams, postBody,
            authNames, contentTypes, accepts, returnType, callback
        );
    }

    /**
     * Callback function to receive the result of the createTemplate operation.
     * @callback module:api/ArchiveApi~createTemplateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InlineResponse2011} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates a template
     * Creates a template for use in the archive. The slug has to be unique. If it already exists, it will result in a 400 response.
     * @param {String} slug 
     * @param {String} template 
     * @param {Object} opts Optional parameters
     * @param {Object} opts.defaultVariables 
     * @param {String} opts.language 
     * @param {String} opts.renderer 
     * @param {String} opts.templateLanguage 
     * @param {module:api/ArchiveApi~createTemplateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/InlineResponse2011}
     */
    createTemplate(slug, template, opts, callback) {
        opts = opts || {};
        let postBody = null;

        // verify the required parameter 'slug' is set
        if (slug === undefined || slug === null) {
            throw new Error("Missing the required parameter 'slug' when calling createTemplate");
        }

        // verify the required parameter 'template' is set
        if (template === undefined || template === null) {
            throw new Error("Missing the required parameter 'template' when calling createTemplate");
        }


        let pathParams = {};
        let queryParams = {};
        let headerParams = {};
        let formParams = {
            'default_variables': opts['defaultVariables'],
            'language': opts['language'],
            'renderer': opts['renderer'],
            'slug': slug,
            'template': template,
            'template_language': opts['templateLanguage']
        };

        let authNames = ['APIKeyHeader'];
        let contentTypes = ['multipart/form-data'];
        let accepts = ['*/*'];
        let returnType = InlineResponse2011;

        return this.apiClient.callApi(
            '/archive/templates', 'POST',
            pathParams, queryParams, headerParams, formParams, postBody,
            authNames, contentTypes, accepts, returnType, callback
        );
    }

    /**
     * Callback function to receive the result of the deleteDocument operation.
     * @callback module:api/ArchiveApi~deleteDocumentCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Removes the specific document
     * Removes the specified document.
     * @param {String} id 
     * @param {module:api/ArchiveApi~deleteDocumentCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteDocument(id, callback) {
        let postBody = null;

        // verify the required parameter 'id' is set
        if (id === undefined || id === null) {
            throw new Error("Missing the required parameter 'id' when calling deleteDocument");
        }


        let pathParams = {
            'id': id
        };
        let queryParams = {};
        let headerParams = {};
        let formParams = {};

        let authNames = ['APIKeyHeader'];
        let contentTypes = [];
        let accepts = ['*/*'];
        let returnType = null;

        return this.apiClient.callApi(
            '/archive/documents/:id', 'DELETE',
            pathParams, queryParams, headerParams, formParams, postBody,
            authNames, contentTypes, accepts, returnType, callback
        );
    }

    /**
     * Callback function to receive the result of the deleteTemplate operation.
     * @callback module:api/ArchiveApi~deleteTemplateCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Removes the specific templates
     * Removes the specified template. If the are documents using the template, a delete will result in a 400 response.
     * @param {String} slug 
     * @param {module:api/ArchiveApi~deleteTemplateCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteTemplate(slug, callback) {
        let postBody = null;

        // verify the required parameter 'slug' is set
        if (slug === undefined || slug === null) {
            throw new Error("Missing the required parameter 'slug' when calling deleteTemplate");
        }


        let pathParams = {
            'slug': slug
        };
        let queryParams = {};
        let headerParams = {};
        let formParams = {};

        let authNames = ['APIKeyHeader'];
        let contentTypes = [];
        let accepts = ['*/*'];
        let returnType = null;

        return this.apiClient.callApi(
            '/archive/templates/:slug', 'DELETE',
            pathParams, queryParams, headerParams, formParams, postBody,
            authNames, contentTypes, accepts, returnType, callback
        );
    }

    /**
     * Callback function to receive the result of the getDocument operation.
     * @callback module:api/ArchiveApi~getDocumentCallback
     * @param {String} error Error message, if any.
     * @param {File} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get a document
     * Returns a specific document file. If the document file is missing, it will be rendered.
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.waitForRenderer If the service does not have a rendered, the server will have the client wait for the renderer. (default to true)
     * @param {module:api/ArchiveApi~getDocumentCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link File}
     */
    getDocument(id, opts, callback) {
        opts = opts || {};
        let postBody = null;

        // verify the required parameter 'id' is set
        if (id === undefined || id === null) {
            throw new Error("Missing the required parameter 'id' when calling getDocument");
        }


        let pathParams = {
            'id': id
        };
        let queryParams = {
            'wait_for_renderer': opts['waitForRenderer']
        };
        let headerParams = {};
        let formParams = {};

        let authNames = ['APIKeyHeader'];
        let contentTypes = [];
        let accepts = ['*/*'];
        let returnType = File;

        return this.apiClient.callApi(
            '/archive/documents/:id', 'GET',
            pathParams, queryParams, headerParams, formParams, postBody,
            authNames, contentTypes, accepts, returnType, callback
        );
    }

    /**
     * Callback function to receive the result of the getDocumentFileId operation.
     * @callback module:api/ArchiveApi~getDocumentFileIdCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InlineResponse2001} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get a documents internal file id
     * Returns a specific document file internal file id.. If the document file is missing, it will be rendered.
     * @param {String} id 
     * @param {module:api/ArchiveApi~getDocumentFileIdCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/InlineResponse2001}
     */
    getDocumentFileId(id, callback) {
        let postBody = null;

        // verify the required parameter 'id' is set
        if (id === undefined || id === null) {
            throw new Error("Missing the required parameter 'id' when calling getDocumentFileId");
        }


        let pathParams = {
            'id': id
        };
        let queryParams = {};
        let headerParams = {};
        let formParams = {};

        let authNames = ['APIKeyHeader'];
        let contentTypes = [];
        let accepts = ['*/*'];
        let returnType = InlineResponse2001;

        return this.apiClient.callApi(
            '/archive/documents/:id/file_id', 'GET',
            pathParams, queryParams, headerParams, formParams, postBody,
            authNames, contentTypes, accepts, returnType, callback
        );
    }

    /**
     * Callback function to receive the result of the getTemplate operation.
     * @callback module:api/ArchiveApi~getTemplateCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InlineResponse2002} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get specific templates
     * Returns all information related to specified template
     * @param {String} slug 
     * @param {module:api/ArchiveApi~getTemplateCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/InlineResponse2002}
     */
    getTemplate(slug, callback) {
        let postBody = null;

        // verify the required parameter 'slug' is set
        if (slug === undefined || slug === null) {
            throw new Error("Missing the required parameter 'slug' when calling getTemplate");
        }


        let pathParams = {
            'slug': slug
        };
        let queryParams = {};
        let headerParams = {};
        let formParams = {};

        let authNames = ['APIKeyHeader'];
        let contentTypes = [];
        let accepts = ['*/*'];
        let returnType = InlineResponse2002;

        return this.apiClient.callApi(
            '/archive/templates/:slug', 'GET',
            pathParams, queryParams, headerParams, formParams, postBody,
            authNames, contentTypes, accepts, returnType, callback
        );
    }

    /**
     * Callback function to receive the result of the listDocuments operation.
     * @callback module:api/ArchiveApi~listDocumentsCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/InlineResponse200>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * List documents
     * Generates a list of the documents in the archive
     * @param {module:api/ArchiveApi~listDocumentsCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/InlineResponse200>}
     */
    listDocuments(callback) {
        let postBody = null;


        let pathParams = {};
        let queryParams = {};
        let headerParams = {};
        let formParams = {};

        let authNames = ['APIKeyHeader'];
        let contentTypes = [];
        let accepts = ['*/*'];
        let returnType = [InlineResponse200];

        return this.apiClient.callApi(
            '/archive/documents', 'GET',
            pathParams, queryParams, headerParams, formParams, postBody,
            authNames, contentTypes, accepts, returnType, callback
        );
    }

    /**
     * Callback function to receive the result of the listTemplates operation.
     * @callback module:api/ArchiveApi~listTemplatesCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/InlineResponse2002>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * List available templates
     * Creates a template for usein the archive
     * @param {module:api/ArchiveApi~listTemplatesCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/InlineResponse2002>}
     */
    listTemplates(callback) {
        let postBody = null;


        let pathParams = {};
        let queryParams = {};
        let headerParams = {};
        let formParams = {};

        let authNames = ['APIKeyHeader'];
        let contentTypes = [];
        let accepts = ['*/*'];
        let returnType = [InlineResponse2002];

        return this.apiClient.callApi(
            '/archive/templates', 'GET',
            pathParams, queryParams, headerParams, formParams, postBody,
            authNames, contentTypes, accepts, returnType, callback
        );
    }

    /**
     * Callback function to receive the result of the updateTemplate operation.
     * @callback module:api/ArchiveApi~updateTemplateCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update specific templates
     * Updates the specified template by creating a new revision of the template.
     * @param {String} slug 
     * @param {String} template 
     * @param {Object} opts Optional parameters
     * @param {Object} opts.defaultVariables 
     * @param {module:api/ArchiveApi~updateTemplateCallback} callback The callback function, accepting three arguments: error, data, response
     */
    updateTemplate(slug, template, opts, callback) {
        opts = opts || {};
        let postBody = null;

        // verify the required parameter 'slug' is set
        if (slug === undefined || slug === null) {
            throw new Error("Missing the required parameter 'slug' when calling updateTemplate");
        }

        // verify the required parameter 'template' is set
        if (template === undefined || template === null) {
            throw new Error("Missing the required parameter 'template' when calling updateTemplate");
        }


        let pathParams = {
            'slug': slug
        };
        let queryParams = {};
        let headerParams = {};
        let formParams = {
            'default_variables': opts['defaultVariables'],
            'template': template
        };

        let authNames = ['APIKeyHeader'];
        let contentTypes = ['multipart/form-data'];
        let accepts = ['*/*'];
        let returnType = null;

        return this.apiClient.callApi(
            '/archive/templates/:slug', 'PATCH',
            pathParams, queryParams, headerParams, formParams, postBody,
            authNames, contentTypes, accepts, returnType, callback
        );
    }


}